import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  simulations: "call",
  sessions: "scenario",
  scores: "simulations",
  certifications: "certifications",
  dashboard: "call",
};

const viewTabsSlice = createSlice({
  name: "viewTabs",
  initialState,
  reducers: {
    setSimulations(state, action) {
      state.simulations = action.payload;
    },
    setSessions(state, action) {
      state.sessions = action.payload;
    },
    setScores(state, action) {
      state.scores = action.payload;
    },
    setCertifications(state, action) {
      state.certifications = action.payload;
    },
    setDashboard(state, action) {
      state.dashboard = action.payload;
    },
  },
});

export const {
  setSimulations,
  setScores,
  setSessions,
  setCertifications,
  setDashboard,
} = viewTabsSlice.actions;
export default viewTabsSlice.reducer;
